import {BaseGraphNode} from "#graph/nodes/base/node"
import type {BaseGraphNodeDefinition, GetParameters, NodeParameters} from "#graph/nodes/base/types"
import type {BaseGraphNodeStatic} from "#graph/nodes/graph/static-types"

const nodeFactory = new Map<string, (new (parameters: NodeParameters, disableValidation?: boolean) => BaseGraphNode) & BaseGraphNodeStatic>()

export function getRegisteredNode(name: string) {
    const retVal = nodeFactory.get(name)
    if (!retVal) {
        throw new Error(`Node class ${name} not found in class factory, forgot to decorate it with @registerNode?`)
    }
    return retVal
}

export function registerNode<Definition extends BaseGraphNodeDefinition>(
    targetClass: {
        new (parameters: GetParameters<Definition>, disableValidation?: boolean): BaseGraphNode<Definition>
    } & BaseGraphNodeStatic<Definition>,
) {
    const nodeClass = targetClass.nodeClass
    if (!(targetClass.prototype instanceof BaseGraphNode)) {
        throw new Error(`Class ${nodeClass} must extend BaseGraphNode to be eligible for registration`)
    }
    const versionChain = targetClass.versionChain

    if (versionChain && !Array.isArray(versionChain)) {
        throw new Error(`Version chain not defined, forgot to decorate ${nodeClass} with @declareNode()?`)
    }

    const register = (name: string) => {
        if (name === "GraphRef") {
            throw new Error(`Entity name ${name} is reserved`)
        }
        if (nodeFactory.has(name)) {
            throw new Error(`Node class ${name} already registered in class factory, double-check your import paths`)
        }
        nodeFactory.set(name, targetClass)
    }

    register(nodeClass)
    versionChain?.forEach((version) => {
        if (version.nodeClass !== undefined) {
            register(version.nodeClass)
        }
    })
}
